import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { ColumnFlex } from '~/components/common/containers'
import NoResults from '~/components/common/no-results'
import StyledSpinner from '~/components/spinner'
import { translate } from '~/core/translate'
import { getHasSearchText, getIsSearching, getRecents, getSearchResults } from '~/selectors/salesforce'

import Item from './item'
import Search from './search'
import { ItemContent } from './styled'

const StyledItem = styled(Item)`
  background-color: transparent;
  padding: 0;

  img {
    margin-top: 12px;
  }

  ${ItemContent} {
    box-shadow: ${({ theme }) => theme.boxShadowSalesforceSearchItem};
    display: grid;
    grid-template-columns: 1fr auto;
    padding: 12px 0;

    ${ColumnFlex}:not(:first-child) {
      flex-direction: column-reverse;
      margin: 0 0 0 auto;

      span:last-child {
        text-align: right;
      }
    }
  }
`

const ResultsText = styled.div`
  font-weight: 600;
  margin: 16px 0 8px;
`

const List = styled.div`
  overflow-y: auto;
`

const Items = ({ onItemSelected }) => {
  const isSearching = useSelector(getIsSearching)
  const hasSearchText = useSelector(getHasSearchText)
  const searchResults = useSelector(getSearchResults)
  const recents = useSelector(getRecents)
  const ids = hasSearchText ? searchResults : recents
  const showNoResultsPage = hasSearchText && !isSearching && !searchResults.length
  const resultsText = hasSearchText
    ? `${translate('search_results')} (${searchResults.length})`
    : translate('salesforce_recents')

  return (
    <div>
      <Search />

      {isSearching
        ? <StyledSpinner />
        : (
          <>
            <ResultsText>{resultsText}</ResultsText>

            {showNoResultsPage
              ? <NoResults />
              : (
                <List>
                  {ids.map(id =>
                    <StyledItem key={id} recordId={id} onSelected={onItemSelected} />
                  )}
                </List>
                )}
          </>
          )}
    </div>
  )
}

export default Items
